import { useEffect, useState } from "react"

import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"

import useDebounce from "../../../../../hooks/use-debounce"
import Images from "../../../../../Images"
import HealthSubpageLayout from "../../../components/HealthSubpageLayout"
import EpsColumnFilters from "../../../components/Monitoring/EpsColumnFilters/EpsColumnFilters"
import { getEmptyEpsFilters, VAMP_EPS_FILTERS } from "../../../components/Monitoring/epsFilters"
import EpsSubpageHeader from "../../../components/Monitoring/EpsSubpageHeader/EpsSubpageHeader"
import HealthActions from "../../../reducer"
import { useBusinessAccountId } from "../../hooks/useBusinessAccountId"
import { useVampHistoricalDataMode } from "../../hooks/useHistoricalDataMode"
import { useVampDescriptor } from "../../hooks/useVampDescriptor"
import EstimatedProgramStatusTable from "./Table/EstimatedProgramStatusTable"

const EstimatedProgramStatusPage = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { userInfo, isAdmin } = useSelector((state) => state.auth)
  const { mainInfo, monitoringInitialized } = useSelector((state) => state.health)

  const business_account_id = useBusinessAccountId()
  const descriptor = useVampDescriptor()
  const [search, setSearch] = useState("")
  const debouncedSearch = useDebounce(search, 400)
  const [columnFilters, setColumnFilters] = useState(() => getEmptyEpsFilters(VAMP_EPS_FILTERS))
  const { isHistoricalDataMode } = useVampHistoricalDataMode()

  useEffect(() => {
    if (!mainInfo && descriptor) {
      dispatch(
        HealthActions.getHealthMainInfoRequest({
          business_account: business_account_id,
          descriptor,
          ...(isHistoricalDataMode ? { historical_data: true } : {})
        })
      )
    }
  }, [business_account_id, descriptor, isHistoricalDataMode])

  useEffect(() => {
    if (!monitoringInitialized) {
      dispatch(HealthActions.monitoringInit({ business_account: business_account_id }))
    }
  }, [])

  return (
    <HealthSubpageLayout backText={t("Back to Health")}>
      <EpsSubpageHeader
        brandLabel="Visa"
        brandImage={Images.visa_3d}
        search={search}
        onSearch={setSearch}
      />
      <EpsColumnFilters
        filtersMap={VAMP_EPS_FILTERS}
        filters={columnFilters}
        onChange={setColumnFilters}
      />
      <EstimatedProgramStatusTable
        variant="page"
        withPagination
        pageSize={50}
        search={debouncedSearch}
        columnFilters={columnFilters}
      />
    </HealthSubpageLayout>
  )
}

export default EstimatedProgramStatusPage
